<div class="p-6 flex-table-page">
  <!-- Page Header -->
  <div class="mb-6 flex justify-between items-center flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "payment_history.management.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
  </app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <app-data-table
      [dataSource]="paymentHistory()"
      [columns]="tableColumns()"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      class="w-full"
    >
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column.prop === "amount") {
          <div class="text-right w-full">
            <span class="font-medium">
              {{ formatCurrency(value, rowData.currency) }}
            </span>
          </div>
        } @else if (column.prop === "payType") {
          <span class="font-normal">
            {{ getPaymentMethodDisplayText(value) | translate }}
          </span>
        } @else if (column.prop === "platform") {
          <span class="font-normal">
            {{ getPaymentPlatformDisplayText(value) | translate }}
          </span>
        } @else if (
          column.prop === "creationDate" || column.prop === "lastUpdateDate"
        ) {
          <span class="text-xs">
            {{ formatDate(value) }}
          </span>
        }
      </ng-template>

      <ng-template #statusTemplate let-status let-rowData="rowData">
        <div class="flex items-center justify-center gap-1">
          <p-tag
            [value]="getPaymentStatusDisplayText(rowData.status) | translate"
            [severity]="getPaymentStatusSeverity(rowData.status)"
            styleClass="status-tag"
            [ngStyle]="getPaymentStatusStyle(rowData.status)"
            [pTooltip]="getPaymentStatusDisplayText(rowData.status) | translate"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </div>
      </ng-template>

      <ng-template #actionsTemplate let-rowData>
        <div class="actions-container flex gap-2 justify-start">
          <app-button
            class="action-view"
            [label]="'payment_history.actions.view' | translate"
            type="action"
            (emitOnClick)="onViewDetails(rowData)"
          ></app-button>
        </div>
      </ng-template>
    </app-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast></p-toast>
